import { ReactNode } from 'react'

import { UNDEFINED_VALUE } from 'const/formatting'
import { CellRenderProps } from 'types'

export function CommaListRenderer<RecordType>({
    value,
    undefinedValue = UNDEFINED_VALUE,
}: CellRenderProps<RecordType>): ReactNode {
    const items = Array.isArray(value)
        ? value.filter(
              (item): item is string =>
                  typeof item === 'string' && item.length > 0
          )
        : []

    if (items.length === 0) {
        return <span>{undefinedValue}</span>
    }

    return (
        <span
            style={{
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}
        >
            {items.join(', ')}
        </span>
    )
}
